module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "relative"
  }, [_c('Back', {
    attrs: {
      "clicked": _vm.goBack
    }
  }), _vm._v(" "), (!_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', {
    staticClass: "rental-closed"
  }, [_c('p', [_vm._v(_vm._s(_vm.SITE_CONFIG.modules_open.skiletting.closed_message))])]) : _vm._e(), _vm._v(" "), (_vm.SITE_CONFIG.modules_open.skiletting.open) ? _c('div', [(parseInt(_vm.$route.params.person)) ? _c('div', {
    staticClass: "remove-user",
    on: {
      "click": function($event) {
        return _vm.remove(_vm.index)
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('skirental.remove-title', {
    skier: ''
  })) + " "), _c('button', {
    staticClass: "white small border"
  }, [_c('icon', {
    attrs: {
      "name": "trash",
      "scale": 1.4
    }
  })], 1)]) : _vm._e(), _vm._v(" "), _c('div', {
    class: 'component ' + (_vm.allProducts.length >= 3 ? 'wider' : '')
  }, [_c('Timeline', {
    attrs: {
      "steps": _vm.timelineSteps
    }
  }), _vm._v(" "), (_vm.$store.state.isOnSite) ? _c('OnSiteFooter') : _vm._e(), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.$t('skirental.pick-products', {
    skier: ''
  })) + " " + _vm._s(_vm.person.name))]), _vm._v(" "), _c('div', {
    staticClass: "blue-bar"
  }, [(_vm.selectedType === 'package') ? _c('b', [_vm._v(_vm._s(_vm.$t('skirental.package', {
    package: ''
  })) + " " + _vm._s(_vm.categories[_vm.selectedCategory]) + ":")]) : _vm._e(), _vm._v(" "), (_vm.selectedType === 'single') ? _c('b', [_vm._v(_vm._s(_vm.categories[_vm.selectedCategory]) + ":")]) : _vm._e(), _vm._v(" "), (_vm.person.type !== 'single' && _vm.person.type !== 'package') ? _c('b', [(_vm.person.onlySkipass) ? _c('b', [_vm._v(_vm._s(_vm.$t('general.skipass')) + ":")]) : _vm._e()]) : _vm._e(), _vm._v("\n      " + _vm._s(_vm.ages[_vm.person.age]) + "\n      "), (_vm.selectedLevel === 'beginner') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.level')) + ":")]), _vm._v(" " + _vm._s(_vm.$t('general.levels.beginner')))]) : _vm._e(), _vm._v(" "), (_vm.selectedLevel === 'intermediate') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.level')) + ":")]), _vm._v(" " + _vm._s(_vm.$t('general.levels.average')))]) : _vm._e(), _vm._v(" "), (_vm.selectedLevel === 'advanced') ? _c('span', [_c('b', [_vm._v(_vm._s(_vm.$t('general.level')) + ":")]), _vm._v(" " + _vm._s(_vm.$t('general.levels.advanced')))]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.$route.query['from-single']) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n        Du tittar nu på våra paketerbjudanden, dessa har ett förmånligare pris än enskilda produkter. Vill du gå tillbaka till "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.goToSingle()
      }
    }
  }, [_vm._v("våra enstaka produkter")]), _vm._v(" istället?\n      ")]) : _vm._e()]), _vm._v(" "), _c('Loading', {
    attrs: {
      "show": _vm.loading
    }
  }), _vm._v(" "), _c('div', {
    class: {
      flex: true, disabled: _vm.loading
    }
  }, _vm._l((_vm.allProducts), function(item) {
    return _c('div', {
      class: {
        box: true, active: (_vm.selectedProducts.indexOf(item) !== -1)
      },
      attrs: {
        "title": (_vm.$store.state.isDebugging) ? item.pool_lid : ''
      },
      on: {
        "click": function($event) {
          return _vm.setActive(item)
        }
      }
    }, [_c('div', {
      staticClass: "image default-image",
      style: (item.image ? 'background-image:url(https://static.booking.branasgruppen.se/static/img/produkter/' + item.image + ')' : 'background-size:cover;')
    }), _vm._v(" "), _c('b', [_vm._v(_vm._s(item.name))]), _vm._v(" "), (item.smalltext) ? _c('p', {
      staticClass: "smalltext"
    }, [_vm._v(_vm._s(item.smalltext))]) : _vm._e(), _vm._v(" "), (item.subtitle) ? _c('p', {
      staticClass: "subtitle"
    }, [_vm._v(_vm._s(item.subtitle))]) : _vm._e(), _vm._v(" "), _c('p', [(!item.buy) ? _c('span', [_vm._v(_vm._s((_vm.person.priceType === 'night' && _vm.SITE_CONFIG.site !== 'vallasen') ? '' : _vm.person.days) + " " + _vm._s((_vm.person.priceType === 'night' ?
      (_vm.SITE_CONFIG.site === 'vallasen' ? _vm.$t('general.night') : _vm.$t('skirental.day-options.hours', {
        hours: _vm.SITE_CONFIG.rental.night_hours
      })) :
      (_vm.person.days > 1 ? _vm.$t('general.days') : _vm.$t('general.day'))
    )))]) : _vm._e(), _vm._v(" "), (item.buy) ? _c('span', [_vm._v(_vm._s(_vm.$t('general.buy')))]) : _vm._e(), _vm._v(" "), _c('b', [_vm._v(_vm._s(_vm._f("currency")(item['price_' + _vm.person.days + (_vm.person.priceType === 'night' ? '_night' : '')])))]), _vm._v(" "), (item['price_' + _vm.person.days + (_vm.person.priceType === 'night' ? '_night' : '')] !== item['price_' + 'original_' + _vm.person.days + (_vm.person.priceType === 'night' ? '_night' : '')]) ? _c('span', {
      staticClass: "original-price"
    }, [_vm._v(_vm._s(_vm._f("currency")(item['price_' + 'original_' + _vm.person.days + (_vm.person.priceType === 'night' ? '_night' : '')])))]) : _vm._e()]), _vm._v(" "), _c('div', [(item.description) ? _c('button', {
      staticClass: "float-left outline-button",
      on: {
        "click": function($event) {
          $event.stopPropagation();
          return _vm.infoPopup(item)
        }
      }
    }, [_c('icon', {
      attrs: {
        "name": "info-blue",
        "scale": 1.4
      }
    }), _vm._v(" " + _vm._s(_vm.$t('general.info-short')))], 1) : _vm._e(), _vm._v(" "), _c('button', {
      class: {
        small: true, green: (_vm.selectedProducts.indexOf(item) !== -1), 'float-right': true
      }
    }, [_vm._v("\n            " + _vm._s(_vm.selectedProducts.indexOf(item) !== -1 ? _vm.$t('general.picked') : _vm.$t('general.pick')) + "\n          ")]), _vm._v(" "), ((_vm.selectedProducts.indexOf(item) !== -1)) ? _c('button', {
      class: 'small trash border float-right'
    }, [_c('icon', {
      attrs: {
        "name": "trash",
        "scale": 1.3
      }
    })], 1) : _vm._e()])])
  }), 0), _vm._v(" "), _c('div', {
    staticClass: "center"
  }, [(_vm.showPackageInfo) ? _c('div', {
    staticClass: "info"
  }, [_vm._v("\n        Du har valt produkter som ingår i paketerbjudanden, dessa har ett förmånligare pris än enskilda produkter. Vill du kolla på "), _c('a', {
    attrs: {
      "href": "#"
    },
    on: {
      "click": function($event) {
        $event.stopPropagation();
        $event.preventDefault();
        return _vm.goToPackages()
      }
    }
  }, [_vm._v("våra paket")]), _vm._v(" istället?\n      ")]) : _vm._e()]), _vm._v(" "), _c('div', {
    staticClass: "center space-3"
  }, [_c('button', {
    attrs: {
      "disabled": _vm.selectedProducts.length === 0 ? true : false
    },
    on: {
      "click": function($event) {
        return _vm.next()
      }
    }
  }, [_vm._v(_vm._s(_vm.$t('general.go-on')))])])], 1)]) : _vm._e()], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-2386a3b0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Pages/SkiRental/SkiRentalUserProducts.vue
// module id = 936
// module chunks = 0